import { pick } from 'ramda';
import type { Skin } from 'c-entity-types';

export const onlySkinThemeValues = (skin?: Skin | null) => {
    if (skin == null) {
        return null;
    }

    return pick(
        [
            'id',
            'updated_at',
            'created_at',
            'name',
            'logo_path',
            'logo_mimetype',
            'logo_small_path',
            'logo_small_mimetype',
            'logo_dark_path',
            'logo_dark_mimetype',
            'logo_small_dark_path',
            'logo_small_dark_mimetype',
            'primary_text_color',
            'secondary_text_color',
            'disabled_text_color',
            'primary_color',
            'secondary_color',
            'third_color',
            'fourth_color',
            'fifth_color',
            'sixth_color',
            'divider_color',
            'card_bg_color',
            'content_bg_color',
            'nav_bg_color',
            'dark_mode_auto',
            'dark_primary_color',
            'dark_secondary_color',
            'dark_third_color',
            'dark_fourth_color',
            'dark_fifth_color',
            'dark_sixth_color',
        ],
        skin,
    ) as Skin;
};
